var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-voice-request-component",
      class: { requested: _vm.isRequestSpeak || _vm.hasRequestSpeak },
    },
    [
      _c("div", { staticClass: "room-voice-request" }, [
        _vm.hasEmceeRole()
          ? _c("div", { staticClass: "room-voice-request-button-container" }, [
              !_vm.isMobile
                ? _c(
                    "span",
                    { staticClass: "room-voice-request-button-text" },
                    [_vm._v(_vm._s(_vm.$t("voice.title")))]
                  )
                : _vm._e(),
              _c("button", {
                staticClass: "room-voice-request-button",
                on: { click: _vm.onToggleVoiceRequestList },
              }),
            ])
          : _c("div", { staticClass: "room-voice-request-button-container" }, [
              !_vm.isMobile
                ? _c(
                    "span",
                    { staticClass: "room-voice-request-button-text" },
                    [
                      _vm._v(
                        _vm._s(
                          !_vm.isRequestSpeak
                            ? _vm.$t("voice.title")
                            : _vm.$t("voice.cancel")
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              _c("button", {
                staticClass: "room-voice-request-button",
                on: { click: _vm.toggleRequestSpeak },
              }),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }